module.exports = __webpack_public_path__ + "img/qr_code.f31c3fe3.svg";